module.exports = __webpack_public_path__ + "img/qingjia.0da343ac.png";